
import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { PRODUCT_CATEGORIES } from '../constants';
import { Home, ChevronRight } from 'lucide-react';

export const Breadcrumb: React.FC = () => {
    const location = ReactRouterDOM.useLocation();
    const { pathname } = location;

    let currentProduct = null;
    let currentCategory = null;

    for (const category of PRODUCT_CATEGORIES) {
        const foundProduct = category.products.find(p => p.path === pathname);
        if (foundProduct) {
            currentProduct = foundProduct;
            currentCategory = category;
            break;
        }
    }

    if (!currentProduct || !currentCategory) {
        return null;
    }

    const crumbs = [
        { name: 'Strona Główna', path: '/' },
        { name: currentCategory.name, path: '#' }, // Category is not a link for now
        { name: currentProduct.title, path: currentProduct.path }
    ];

    return (
        <nav aria-label="breadcrumb" className="container mx-auto px-4 -mt-8 mb-8 relative z-10">
            <ol className="flex items-center space-x-2 bg-content-light dark:bg-content-dark px-4 py-2 rounded-full shadow-sm border border-border-light dark:border-border-dark w-fit">
                {crumbs.map((crumb, index) => {
                    const isLast = index === crumbs.length - 1;
                    return (
                        <li key={index} className="flex items-center">
                            {index > 0 && <ChevronRight className="w-4 h-4 text-text-secondary-light dark:text-text-secondary-dark mx-2" />}
                            <ReactRouterDOM.Link
                                to={isLast ? '#' : crumb.path}
                                aria-current={isLast ? 'page' : undefined}
                                className={`text-sm ${
                                    isLast
                                        ? 'font-semibold text-text-primary-light dark:text-text-primary-dark cursor-default'
                                        : 'text-text-secondary-light dark:text-text-secondary-dark hover:text-primary-light dark:hover:text-primary-dark transition-colors'
                                }`}
                            >
                                {index === 0 && <Home className="w-4 h-4 inline-block mr-1" />}
                                {crumb.name}
                            </ReactRouterDOM.Link>
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};
